import { ProcessTypeConfigModel } from "../../models/processTypeConfigModel";
import { SetProcessCreateOtherSectionVisibility } from "../processOtherSection";

export function updateNMTKFieldVisibility(config: ProcessTypeConfigModel) {
    let $nmtkRow: JQuery<HTMLElement> = $('#nmtk-plan-row');
    let $nmtkHelper: JQuery<HTMLElement> = $('#nmtk-helper');

    if (config.NeedToDisplayNMTKField) {
        SetProcessCreateOtherSectionVisibility(true);
        $nmtkRow.show();
        $nmtkHelper.show();
    } else {
        $nmtkRow.hide();
        $nmtkHelper.hide();
        SetProcessCreateOtherSectionVisibility(false);
    }
}
